import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { Animated, ImageProps, ImageSourcePropType, StyleSheet } from 'react-native';
import { store } from '../../store/store';
import { ImageOptions } from '../Image';
import { isMobile } from '../utils/platformCheck';
import { sleep } from '../utils/sleep';
import { LoadImagesAtOnce } from './index';


interface WaitForLoadImageProps extends ImageProps {
    partials?: React.ReactElement[],
    options?: ImageOptions,
    callback?: () => void,
    canvasStyle?: CSSProperties,
    duration?: number,
    onFinishedPainting?: (image: any) => void;
    children?: React.ReactNode;
    disableAnimation?: boolean;
    hoveredTriggered?: (image: string | null) => void;
    clickableItem?: (item?: string | null) => void;
}
type names = "imageToShow" | "realSource";
export const WaitForLoadImage: React.FC<WaitForLoadImageProps> = React.memo(({ source, style, canvasStyle, partials, options, children, duration, callback, clickableItem, hoveredTriggered, disableAnimation = false, onFinishedPainting, ...rest }) => {
    const styles = StyleSheet.create({
        image: {
            position: "absolute",
            width: "100%",
            height: "100%"
        }

    });
    const previousSource = useRef<ImageSourcePropType>();
    const queue = useRef<{ image: ImageSourcePropType, partials: React.ReactElement[]; }[]>([]);
    let isQueueRunning = useRef<boolean>(false);
    const opacity = useRef(new Animated.Value(1));
    const transition = useRef(new Animated.Value(1));
    const [realSource, setRealSource] = useState<{ image: ImageSourcePropType, partials: React.ReactElement[]; }>();
    const [imageToShow, setImageToShow] = useState<{ image: ImageSourcePropType, partials: React.ReactElement[]; }>();
    const loadingRealImage = useRef(false);
    const loadingFakeImage = useRef(false);
    const isAnimating = useRef(false);
    const nextImage = useRef<{ image: ImageSourcePropType, partials: React.ReactElement[]; }>();
    let order = useRef<names>("imageToShow");
    const shakeAnimation = useRef(new Animated.Value(0));

    const wipe = useRef(new Animated.Value(0));


    const [imagesArr, setImagesArr] = useState<React.ReactElement[]>([]);

    useEffect(() => {
        if (!source) { return; }
        if (options?.transition) {
            // TODO: transition
            // debugger;
        }
        if (!imageToShow) {
            setImageToShow({ image: source, partials: partials || [] });
            return;
        }

        queue.current.push({ image: source, partials: partials || [] });
        handleQueue();
        previousSource.current = source;
        return () => {
        };

    }, [source, partials]);


    useEffect(() => {
        // console.log("*************triggered use effect for imageToShow*************", imageToShow);
        if (!imageToShow) { return; }
        handleChangeImages();

    }, [imageToShow]);
    useEffect(() => {
        // console.log("************triggered use effect for realSource*********", realSource);
        if (!realSource) { return; }
        handleChangeImages();

    }, [realSource]);

    useEffect(() => {
        if (isMobile()) {
            // doAnimate();
        }
        // wipe.current.setValue(1920);
        // wipeAnim();

    }, [imagesArr]);
    const handleChangeImages = () => {
        // console.log("handleChangeImages", loadingRealImage.current, loadingFakeImage.current);
        if (loadingRealImage.current || loadingFakeImage.current) {
            // queue.current.push(source);
            handleQueue();
            //console.log("queue", queue);
        } else {

            setImage();
        }
    };
    const checkImagesState = () => {
        if (order.current === "imageToShow") {
            // console.log("setImageToShow", nextImage.current);
            setImageToShow(nextImage.current);

        } else {
            // console.log("setRealSource", nextImage.current);
            setRealSource(nextImage.current);

        }
    };

    const handleQueue = () => {
        if (isQueueRunning.current) {
            return;
        }
        isQueueRunning.current = true;
        return new Promise(async (res) => {
            setTimeout(async () => {
                while (queue.current.length > 0) {
                    if (!loadingFakeImage.current && !loadingRealImage.current) {
                        nextImage.current = queue.current.shift() as any;
                        // console.log("DID QUEUE SHIFT on", nextImage.current);
                        //console.log("trying to put image: ", nextImage.current);
                        checkImagesState();
                        if (queue.current.length > 20) {
                            queue.current = queue.current.slice(20);
                        }
                    }
                    await sleep(store.getState().menu.settings.skipSpeedValue || 5);

                }
                isQueueRunning.current = false;
                res(true);

            });
        });

    };


    const setImage = () => {
        opacity.current.setValue(0);
        if (order.current === "imageToShow") {


            setImagesArr([getRealImage(), getImageToShow()]);
            onFinishedPainting?.(imageToShow?.image);
            order.current = "realSource";
        } else {
            //console.log("setImage realSource");
            setImagesArr([getImageToShow(), getRealImage()]);
            onFinishedPainting?.(realSource?.image);
            order.current = "imageToShow";
        }
    };
    const getRealImage = () => {

        return <LoadImagesAtOnce hoveredTriggered={hoveredTriggered} clickableItem={clickableItem}
            canvasStyle={canvasStyle}  {...rest} onLoadStart={() => { onRealloadstart(); }}
            onLoadEnd={(image) => { onRealFinishLoading(); }} _key={"image1"} key={"image1"} style={[{ height: "100%", width: "100%", position: "absolute" }, { opacity: order.current == "realSource" ? opacity.current : 1 }]} source={realSource}></LoadImagesAtOnce>;
    };
    const getImageToShow = () => {

        return <LoadImagesAtOnce hoveredTriggered={hoveredTriggered} clickableItem={clickableItem} {...rest}
            canvasStyle={canvasStyle} onLoadStart={() => { onloadstart(); }}
            onLoadEnd={(image) => {
                onFinishLoading();
            }} _key={"image2"} key={"image2"} style={[{ height: "100%", width: "100%", position: "absolute" }, { opacity: order.current == "imageToShow" ? opacity.current : 1 }]} source={imageToShow}></LoadImagesAtOnce>;

    };

    const onloadstart = async () => {
        //console.log("onloadstart", imageToShow);
        loadingFakeImage.current = true;

    };
    const onFinishLoading = async () => {
        //console.log("onFinishLoading", imageToShow);

        loadingFakeImage.current = false;
        doAnimate();

    };
    const onRealloadstart = async () => {
        //console.log("onRealloadstart", realSource);
        loadingRealImage.current = true;

    };
    const onRealFinishLoading = async () => {
        //console.log("onRealFinishLoading", realSource);
        loadingRealImage.current = false;

        doAnimate();


    };

    function shake() {
        Animated.sequence(
            [
                Animated.timing(shakeAnimation.current, { toValue: 20, duration: 45, useNativeDriver: true }),
                Animated.timing(shakeAnimation.current, { toValue: -20, duration: 45, useNativeDriver: true }),
                Animated.timing(shakeAnimation.current, { toValue: 20, duration: 45, useNativeDriver: true }),
                Animated.timing(shakeAnimation.current, { toValue: -20, duration: 45, useNativeDriver: true }),
                Animated.timing(shakeAnimation.current, { toValue: 0, duration: 0, useNativeDriver: true })
            ]
        ).start(({ finished }) => {
            // console.log(finished);
            if (!finished) {
                shakeAnimation.current.setValue(0);
            }

        });
    };
    function wipeAnim() {
        Animated.timing(wipe.current, {
            toValue: 0,
            duration: 1000,
            useNativeDriver: true
        }).start(({ finished }) => {

        });
    };
    const doAnimate = () => {
        if (disableAnimation) {
            opacity.current.setValue(1);
        }

        if (isAnimating.current) { return; }

        if (options?.transition) {
            // doTransition();
            // return;
        }
        if (options?.shake) {
            shake();
        } else {
            shakeAnimation.current.setValue(0);
        }

        // console.log("doAnimate", opacity);
        isAnimating.current = true;
        Animated.timing(opacity.current, {
            toValue: 1,
            duration: duration || (options?.duration != null ? (options?.duration * 1000) + 50 : 300),
            useNativeDriver: true
        }).start(({ finished }) => {
            // console.log("doAnimate finished");
            isAnimating.current = false;
            // console.log("opacity.current", opacity.current);
            // opacity.current.setValue(1);
            /* completion callback */
            // console.log("animation finished:", finished, opacity);

            if (callback) {
                callback();
            }
        });
    };
    return (
        <Animated.View style={[{ transform: [{ translateX: shakeAnimation.current }], backgroundColor: "black" }, style]}>
            <>
                {imagesArr.map(image => (image))}
                {children}
            </>
        </Animated.View>

    );
});;